<template>
  <div class="table-content">
    <div class="top-tools">
      <div class="list-top">
        <label class="title">模板名称</label>
        <el-input placeholder="请输入" size="small" v-model.trim="searchParams.templateName" clearable></el-input>
        <label class="title">类型</label>
        <el-select placeholder="全部" size="small" v-model="searchParams.type" clearable>
          <el-option label="系统模板" value="1"></el-option>
          <el-option label="自定义模板" value="2"></el-option>
        </el-select>
        <el-button size="small" class="org-btn search-btn" @click="searchAjax()">查询</el-button>
        <el-button class="addbtn org-btn is-plain" type="primary" size="small" @click="addTemplate" v-if='blankFlage==2' plain>+ 新建模板</el-button>
      </div>
    </div>
    <div class="btn-tools" v-if='blankFlage==3'>
      <el-button class="addbtn org-btn is-plain" type="primary" size="small" @click="addTemplate" plain>+ 新建模板</el-button>
      <el-button class="addbtn org-btn is-plain copy2" size="small" @click="copyAppId('wx871bfe1fb90bf87d', '.copy2')">复制AppID</el-button>
    </div>
    <el-table style="width: 100%" :data="tableData" border class="list-table" v-loading="listLoading" tooltip-effect="dark">
      <el-table-column prop="templateName" min-width="200px" class-name='templateNameTag' label="模板名称">
        <template slot-scope="scope">
          <tooltip :txt-info="scope.row.templateName"></tooltip>
          <div class="tag" v-if="scope.row.isDefault==1">默认</div>
        </template>
      </el-table-column>
      <el-table-column prop="type" min-width="100px" label="类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.type==1">系统模板</span>
          <span v-if="scope.row.type==2">自定义模板</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" min-width="200px" label="更新时间" show-overflow-tooltip>
        <template slot-scope="scope">{{scope.row.updateTime|timeSubstr(0,16)}}</template>
      </el-table-column>
      <el-table-column prop="createTime" min-width="200px" label="创建时间" show-overflow-tooltip>
        <template slot-scope="scope">{{scope.row.createTime|timeSubstr(0,16)}}</template>
      </el-table-column>
      <el-table-column prop="remark" min-width="200px" label="备注" show-overflow-tooltip></el-table-column>

      <el-table-column prop="" min-width="180px" label="推广路径" fixed="right">
        <template slot-scope="scope">
          <el-button-group>
            <el-popover placement="bottom" width="160" trigger="hover" popper-class="template-popover" @show="showXcxCode(scope.row)">
              <canvas class="canvas-img" :id="'canvas'+scope.row.id" style="display:none"></canvas>
              <el-image :src="blankFlage==3?indexImg:QRCodeImg" class="qrcode-img">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <!-- H5 -->
              <div class="text" @click="downloadCode('canvas'+scope.row.id,scope.row.templateName)" v-if="blankFlage==2">下载二维码</div>
              <!-- 小程序 --> 
              <div class="text" @click="downloadXcxCode()" v-if="blankFlage==3">下载二维码</div>
              <el-button type="text" size='small' slot="reference">二维码</el-button>
            </el-popover>
            <el-button type="text" size='small' @click="copyUrl(scope.row.indexUrl)" v-if="blankFlage==2">复制链接</el-button>
            <el-button type="text" size='small' @click="copyXcxUrl(scope.row)" v-if="blankFlage==3">复制首页路径</el-button>
          </el-button-group>
        </template>
      </el-table-column>
      <el-table-column prop="" min-width="280px" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button-group>
            <!-- 编辑：isSelfCustom=1时才可以编辑，isSelfCustom=0不能编辑；复制：都可以复制；删除：isSelfCustom=1并且isDefault=0才能删除；设为默认：isDefault=0才能设置 -->
            <el-button type="text" size='small' @click="preview(scope.row)">预览</el-button>
            <el-button type="text" size='small' v-if="scope.row.isSelfCustom==1" @click="modifyTemplate(scope.row)">编辑</el-button>
            <el-button type="text" size='small' @click="copyTemplate(scope.row)">复制</el-button>
            <el-button type="text" size='small' v-if="scope.row.isSelfCustom==1&&scope.row.isDefault==0" @click="del(scope.row)">删除</el-button>
            <el-button type="text" size='small' :class="{'disabled':scope.row.isDefault!=0}" @click="setDefault(scope.row)">设为默认模板</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="page" @size-change="handleSizeChange" :current-page.sync='pageNum' background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]"
      @current-change="handleCurrentChange" :total="total"></el-pagination>
      <!-- <preview ref="previewRef"></preview> -->
  </div>
</template>
<script>
import { pageTool } from '@/api/mixins'
import tooltip from "@/components/tooltip";
import Clipboard from "clipboard";
import common from "../../../api/common.js";
// import preview from './preview.vue'
var QRCode = require("qrcode");
export default {
  mixins: [pageTool],
  props:['blankFlage'],
  data: () => ({
    userinfo:{},
    indexImg:'',
    QRCodeImg:'',
  }),
  components:{
    tooltip,
    // preview
  },
  watch:{
    'blankFlage':{
      handler(val){
        this.initListAjax('/master/website/queryWebsiteList')
      },
      immediate:true,
      deep:true
    }
  },
  created() {
    this.userinfo = this.$tools.getLocal("userinfo");
  },
  methods: {
    showXcxCode(item){
      if(this.blankFlage==2){
        this.codesc('canvas'+item.id,item.indexUrl)
        return
      }
      if(this.blankFlage==3){
        let params={
          scene: `${this.userinfo.mechanCode}$${item.code}`,
          page: "pages/index",
        }
        this.$http({
          url: "/api/webappInsure/qrCode",
          type: "post",
          params: params,
        }).then((data)=> {
          this.indexImg = this.$config.api_root + data.data;
        })
      }
    },
    downloadXcxCode(){
      console.log('this.indexImg',this.indexImg)
      // location.href=this.indexImg
      this.$tools.daochu2(this.indexImg);
    },
    // 设置自定义参数
    setListParams(params) {
      params.websiteType=this.blankFlage
      this.$tools.delNull(params)
    },
     modifyTemplate(item) {
      let params={
        templateName:item.templateName,
        remark:item.remark
      }
      sessionStorage.setItem('WEBSITE_TEMP_INFO',JSON.stringify(params))
      // 优化操作逻辑，先去掉这部分
      // if (item.isSelfCustom != 1) {
      //   // 系统模板编辑
      //   this.$router.push({
      //     path: '/editDefTempalte',
      //     query: {
      //       websiteId: item.id,
      //       websiteType: this.blankFlage,
      //     },
      //   })
      // }else {
        // 编辑
        this.$router.push({path:'/addWebSiteTempalte',query:{'websiteType':this.blankFlage,'isSelfCustom':item.isSelfCustom,id:item.id}})
      // }
    },
    // 设置自定义参数
    setListParams(params) {
      params.websiteType=this.blankFlage
      this.$tools.delNull(params)
    },
    // 复制模板
    copyTemplate(item){
      this.$http({
        url:'/master/website/copyWebsite',
        type:'POST',
        params:{
          websiteId:item.id,
          websiteType:this.blankFlage
        }
      }).then(res=>{
        if(res.httpCode==200){
          this.$message.success('复制成功')
          this.getList()
        }
      })
    },
    // 新增模板
    addTemplate(){
      this.$router.push({path:'/addWebSiteTempalte',query:{'websiteType':this.blankFlage}})
    },
    // 删除
    del(row){
      this.$confirm('此操作将永久删除该模板，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http({
          url:`/master/website/deleteWebsite?websiteId=${row.id}`,
          type:'DELETE',
        }).then(res=>{
          if(res.httpCode==200){
            this.$message({
              type: 'success',
              message: '删除成功！'
            });
            this.searchAjax()
          }
        })
      }).catch(e=>{})
    },
    // 设置默认模板
    setDefault(item){
      this.$http({
        url:'/master/website/setDefault',
        type:'POST',
        params:{
          websiteId:item.id,
        }
      }).then(res=>{
        if(res.httpCode==200){
          this.$message.success('设置成功')
          this.getList()
        }
      })
    },
    // 预览
    preview(item){
      // h5预览
      // if(this.blankFlage==2){
        window.open(`${item.indexUrl}&isMobile=true`)
      // }else if(this.blankFlage==3){
      //   // 小程序
      //   this.$refs.previewRef.open(item.id,this.blankFlage)
      // }
    },
    // 复制
    copyUrl(url) {
      let finaUrl = `${url}&isMobile=true`
      this.getShortLink(finaUrl)
    },
    // 复制小程序首页路径
    copyXcxUrl(item){
      let url = `pages/index?scene=${this.userinfo.mechanCode}$${item.code}`
      this.$tools.copyUrl(url)
    },
    getShortLink(finaUrl) {
      this.$http({
        url: "/bplatTool/transformLongUrl",
        type: "put",
        params: {
          url: encodeURIComponent(finaUrl)
        }
      }).then(res => {
        this.$tools.copyUrl(res.data)
      });
    },
    // 显示二维码
    codesc(id, url) {
      var canvas = document.getElementById(id)
      QRCode.toCanvas(canvas, url, {margin:0, width: 140, height: 140 }, function(
        error
      ) {
        if (error) console.error(error);
        console.log("success!");
      });
      this.QRCodeImg = document.getElementById(id).toDataURL('image/png')
    },
    // 下载二维码
    downloadCode(id, name) {
      var url = document.getElementById(id).toDataURL('image/png')
      this.$tools.dataToBlob(name, url)
    },
    // 分页
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    copyAppId(link, id) {
      var clipboard = new Clipboard(id, {
        text: ()=> {
          return link;
        },
      });
      clipboard.on("success", (e)=> {
        this.linkVisible = false;
        this.$message({
          message: "复制成功",
          type: "success",
        });
        clipboard.destroy();
      });
    },
  },
}
</script>
<style lang='scss' scoped>
  .table-content {
    padding: 0 30px;
    .top-tools {
      margin-bottom: 20px;
      .list-top {
        .el-input,
        .el-select {
          width: 20%;
          margin-right: 30px;
        }
        .title {
          font-size: 14px;
          color: #333333;
          margin-right: 10px;
          word-break: keep-all;
        }
        .search-btn {
          font-size: 14px;
          width: 80px;
        }
        .addbtn {
          font-size: 14px;
          margin-left: 20px;
          width: 100px;
        }
      }
    }
    .btn-tools{
      margin-bottom: 15px;
    }
    .list-table .el-table__fixed-right .el-table__fixed-body-wrapper tbody tr:hover {
        background-color: #FFFFFF !important;
    }
    .list-table {
      &::v-deep{
        .el-table__fixed-right{
          height: 100% !important;
        }
        tbody{
          tr{
            background-color: #FFFFFF !important;
            td { background-color: #FFFFFF !important}
          }
        }
        .templateNameTag {
          .cell {
            display: flex;
            align-items: center;
            justify-content: center;
            .wordnowrap{
              max-width: calc(100% - 50px);
            }
          }
        }
        .el-button-group {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
      .disabled{
        pointer-events: none;
        filter:grayscale(1);
        opacity: 0.7;
      }
      .tag {
        display: inline-block;
        text-align: center;
        margin-right: 3px;
        margin-left: 5px;
        border: 1px solid #fd9201;
        width: 32px;
        height: 18px;
        border-radius: 2px;
        font-size: 12px;
        line-height: 16px;
        color: #fd9201;
      }
    }
  }
</style>
<style lang='scss'>
.template-popover {
  padding: 0;
  min-width: 200px;
  text-align: center;
  .text {
    position: relative;
    top: -15px;
    cursor: pointer;
    color: #fd9201;
  }
  .qrcode-img,.canvas-img{
    width:140px;
    height:140px;
    margin: 20px 0;
  }
  .image-slot{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 26px;
  }
}
</style>